var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.014,
    height: 13.22,
    viewBox: "0 0 13.014 13.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.382,2.551c-1.384,0-2.526-.9-4.266-.9a5.018,5.018,0,0,0-1.757.31,1.446,1.446,0,1,0-2.177.67V12.6a.62.62,0,0,0,.62.62h.413a.62.62,0,0,0,.62-.62V10.163A7.214,7.214,0,0,1,5.79,9.592c1.384,0,2.526.9,4.266.9a5.405,5.405,0,0,0,3.163-1.055.825.825,0,0,0,.357-.681V2.477A.826.826,0,0,0,12.4,1.728a7.517,7.517,0,0,1-3.02.822Z",
    transform: "translate(-0.563 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.a27f3296ef898ad8e951b9aa26cc282e.svg";
export { ForwardRef as ReactComponent };